import React , {Component,Fragment} from 'react';
import JobsService from '../../../services/JobsService';
import JobCard from './Reuseable/JobCard';
import ReactPaginate from 'react-paginate';
import qs from 'qs';
import Jobs from './jobs.json';


export default class Index extends Component{
    constructor(props){
        super(props);
        let search  = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).search;
        let page  = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).page;
        search = search == null? "": search;
        page = page == null? "": page;
        this.state = {
            jobs : [],
            search : search,
            page : page,
            perPage : 1,
            loading : true
        };
        this.JobsService = new JobsService('indonesian');
        this.handleSearch = this.handleSearch.bind(this);
        this.callApi = this.callApi.bind(this);
        this.updateURL = this.updateURL.bind(this);
    };

    updateURL(){
        this.props.history.push(`?page=${this.state.page}&search=${this.state.search}`);
    }

    async handleSearch(e){
        let value = e.target.value;
        this.setState({
            search : value
        })

        if(this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
            this.setState({
                page : 1,
            });
            this.updateURL();
            if(this.state.search == "" || this.state.page == ""){
                this.setState({
                    jobs : []
                });
                return;
            }
            await this.callApi();
        }, 750);
    }

    async callApi(){
        let response = await JobsService.search(`page=${this.state.page}&search=${this.state.search}`);
        this.setState({
            jobs : response.data,
            pageCount : response.headers['x-wp-totalpages']
        });
    }

    async componentDidMount(){
        // if(this.state.search == "" || this.state.page == "")
        //     return;
        // await this.callApi();
        const jobs = await this.JobsService.jobs;
        this.setState({
            jobs : jobs,
            loading : false
        })
        
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let page = Math.ceil(selected * this.state.perPage)+1;
        
        this.setState({ page: page }, () => {
            this.updateURL();
            this.callApi();
        });
    };
    // getDerivedStateFromProps(props, state){

    // }

    render(){
        return(
            <Fragment>
                <div class="container pt-5">
                    <div class="row">
                        <div class="col-sm-1">
                        </div>
                        <div class="col-sm-12 pb-5">
                            <h1 class="font-weight-bold">DAFTAR KARIR</h1>
                            {/* <input className="form-control form-control-lg mt-2" placeholder="search anything" onChange={this.handleSearch} value={this.state.search}></input> */}
                            
                            {
                            this.state.loading?
                                <div class="d-flex justify-content-center">
                                    <div class="spinner-grow" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            :
                                this.state.jobs.map(job => {
                                    return(
                                        <JobCard job={job._rawData}></JobCard>
                                    );
                                })}
                            {/* {
                                this.state.jobs.length > 0 
                                    &&
                                <ReactPaginate
                                previousLabel={'previous'}
                                nextLabel={'next'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}


                                breakClassName={'page-item'}
                                breakLinkClassName={'page-link'}
                                pageClassName={'page-item'}
                                pageLinkClassName={'page-link'}
                                previousClassName={'page-item'}
                                previousLinkClassName={'page-link'}
                                nextClassName={'page-item'}
                                nextLinkClassName={'page-link'}
                                />
                            } */}
                        </div>
                        <div class="col-sm-1">
                        </div>
                    </div>

                </div>
            </Fragment>
        );
    };
}